import { matchesInsuranceList } from "@/src/lib/special-cases/evaluate-special-cases";

/**
 * Payers ops wants visually flagged on the sync-instructions Insurance step — these plans have
 * special-case handling ops needs to remember, distinct from the referral/authorization
 * requirements already driven by insurance-grid.ts. PIMC also appears as a named payer in
 * insurance-grid.json's case-policy rows; both the acronym and full name are listed here so the
 * fuzzy match catches either form on the referral.
 */
export const TPR_SPECIAL_CASE_INSURANCE_PAYERS: readonly string[] = [
  "PIMC",
  "Phoenix Indian Medical Center",
  "Triwest",
  "MercyCare",
];

export function isTprSpecialCaseInsurance(payerName: string | null | undefined): boolean {
  const trimmed = payerName?.trim();

  if (!trimmed) return false;

  return matchesInsuranceList(trimmed, [...TPR_SPECIAL_CASE_INSURANCE_PAYERS]);
}
